export default [
  {
    path: '/admin/apply/message/center',
    name: 'messageCenter',
    component: () => import('@/views/message/center'),
    meta: {
      title: '消息中心',
      headType: 0,
      auth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/apply/message.js